import { Field, Form, Formik } from "formik"
import React, { useState } from "react"
import api from "../../../service/api"
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast"
import Button from "../../Button"
import Dropzone from "../../Dropzone"
import { IStepFour } from "./interface"
import { ContainerDropzone, Info, RowForInput, Title, TitleField } from "./style"

const StepFour = (props: IStepFour) => {
    const [selectedFileDocument, setSelectedFileDocument] = useState<File>();
    const [selectedFileResidence, setSelectedFileResidence] = useState<File>();
    const [selectedFileActivity, setSelectedFileActivity] = useState<File>();
    const [selectedFileCnpj, setSelectedFileCnpj] = useState<File>();
    const [messageError, setMessageError] = useState("")
    const [addMessageError, setAddMessageError] = useState(false);

    const showError = (show: boolean, error?: string ) => {
        if(show){
          setMessageError(error as string);
          
          return setAddMessageError(true);
        } 
        
        else {
          setMessageError("");
          
          return setAddMessageError(false);
        }
      }

    const postIdentification = async () => {
        toastCreate("submit", "info" , 1000, "Carregando...");
        const doc = new FormData();
        
        try {
          if(selectedFileDocument) {
            doc.append("filename" , selectedFileDocument);
            const { data } = await api.patch(`/adm/ownerbranch/import/docs?sellerOwnerPayId=${props.data.sellerOwnerPayId}&category=identificacao`, 
            doc);
            
            if(data.status_code === 404){
              throw new Error()
            }
            showError(false);
            toastUpdate("submit", "success" , 3000, "Documento de identificação enviado")
    
          }
        } catch (error) {
          showError(true, "Erro ao enviar a identificação");
          toastUpdate("submit", "error" , 3000, "Falha ao enviar a identificação")
        }
      }
    
      const postResidence = async () => {
        toastCreate("submit", "info" , 1000, "Carregando...");
        const resi = new FormData();
        
        try {
          if(selectedFileResidence) {
            resi.append("filename" , selectedFileResidence);
            await api.patch(`/adm/ownerbranch/import/docs?sellerOwnerPayId=${props.data.sellerOwnerPayId}&category=residencia`, 
            resi);
            toastUpdate("submit", "success" , 3000, "Documento de residência enviado")
          }
          showError(false);
        } catch (error) {
          showError(true, "Erro ao enviar a residência");
          toastUpdate("submit", "error" , 3000, "Falha ao enviar a residência")
        }
      }
    
      const postActivity = async () => {
        toastCreate("submit", "info" , 1000, "Carregando...");
        const act = new FormData();
        
        try {
          if(selectedFileActivity) {
            act.append("filename" , selectedFileActivity);
            await api.patch(`/adm/ownerbranch/import/docs?sellerOwnerPayId=${props.data.sellerOwnerPayId}&category=atividade`, 
            act);
            toastUpdate("submit", "success" , 3000, "Documento de atividade enviado")
            showError(false)
          }
        } catch (error) {
          showError(true, "Erro ao enviar a atividade");
          toastUpdate("submit", "error" , 3000, "Falha ao enviar a atividade")
        }
      }
    
      const postCnpj = async () => {
        toastCreate("submit", "info" , 1000, "Carregando...");
        const cnpj = new FormData();
        
        try {
          if(selectedFileCnpj && props.data.clientType === 1) {
            cnpj.append("filename" , selectedFileCnpj);

            await api.patch(`/adm/ownerbranch/import/docs?sellerOwnerPayId=${props.data.sellerOwnerPayId}&category=cnpj`, 
            cnpj);
            toastUpdate("submit", "success" , 3000, "Documento de CNPJ enviado")
            showError(false);
            
          }
        } catch (error) {
          showError(true, "Erro ao enviar o CNPJ");
          toastUpdate("submit", "error" , 3000, "Falha ao enviar o CNPJ")
        }
      }
    
      return (
        <Formik
            initialValues={{

            }}
            onSubmit={() => {}}
        >
            {({}) => {
                return (
                    <Form>
                        <TitleField>Documentos</TitleField>
                        <RowForInput>
                            <ContainerDropzone className="d-flex flex-column justify-content-between">
                            <Title className="mb-3" >Identificação</Title>
                            <Field id="document_file" name="document_file" type=".pdf" onFileUploaded={setSelectedFileDocument} as={Dropzone}/>
                            <Info className="my-3" >Documento (RG, CPF ou CNH) ou Cartão CNPJ (no caso de PJ).</Info>
                                <Button type="button" onClick={() => {postIdentification()}}> Enviar </Button>
                            </ContainerDropzone>
                            <ContainerDropzone className="d-flex flex-column justify-content-between">
                            <Title className="mb-3" >Residência</Title>
                            <Field id="residence_file" name="residence_file" type=".pdf" onFileUploaded={setSelectedFileResidence} as={Dropzone}/>
                            <Info className="my-3" >Conta de luz, telefone ou gás no nome do proprietário do estabelecimento ou de familiares.</Info>
                            <Button  type="button" onClick={() => {postResidence()}} > Enviar </Button>
                            </ContainerDropzone>
                        </RowForInput>

                        <RowForInput>
                            <ContainerDropzone className="d-flex flex-column justify-content-between">
                            <Title className="mb-3" >Atividade</Title>
                            <Field id="activity_file" name="activity_file" type=".pdf" onFileUploaded={setSelectedFileActivity} as={Dropzone}/>
                            <Info className="my-3" >Alvará, nota fiscal de compras de produtos ou cartão de visitas do estabelecimento.</Info>
                            <Button  type="button" onClick={() => {postActivity()}} > Enviar </Button>
                            </ContainerDropzone>
                        {
                            props.data.clientType === 1
                            ?
                                <ContainerDropzone className="d-flex flex-column justify-content-between">
                                <Title className="mb-3" > CNPJ </Title>
                                <Field id="activity_file" name="activity_file" type=".pdf" onFileUploaded={setSelectedFileCnpj} as={Dropzone}/>
                                <Info className="my-3" >Comprovante de Inscrição e de Situação Cadastral.</Info>
                                <Button type="button" onClick={() => {postCnpj()}} > Enviar </Button>
                                </ContainerDropzone>
                            : null
                        }
                        </RowForInput>
                    </Form>
                )
            }}
            
        </Formik>
    )
}

export default StepFour